import React from 'react';

import loadingSpinner from '../../images/icons/loader.png';
import './loader-utils.scss';

const Loader = ({ loading }) => {
	return loading ? (
		<div className="loader-container">
			<img src={loadingSpinner} alt="Loading" />
		</div>
	) : null;
};

const NoResult = ({ noResult, type }) => {
	const textMap = {
		'article_graph': 'No articles selected.',
		'barometers': 'No barometer stats available.',
		'cart-carousel': 'No bought-with products found.',
		'cart-explorer': 'No product data found. Please select a different product.',
		'earnings-graph': 'Insufficient graph data.',
		'megatable-articles': 'No articles found. Please modify date range.',
		'megatable-smartlinks': 'No Smartlinks found. Please modify date range.',
		'megatable-products': 'No products found. Please modify date range.',
		'megatable-merchantArticles': 'No articles found. Please modify date range.',
		'megatable-merchantRecommendations': 'No recommendations found. Please modify date range.',
		'merch-ed-overview': "No merchants found",
		'merchant-overview': 'No merchant overview data available.',
		'minitable-merchant_epc': 'No stats available.',
		'minitable-merchant_clicks': 'No stats available.',
		'minitable-feed_difference_counts': 'No differences for this merchant. ' +
			'The feed most likely ran successfully.',
		'minitable-feed_differences_by_field': 'No differences for this field name. ' +
			'The feed most likely does not contain this field.',
		'product-trends': 'No best sellers found. Please select a different merchant.',
		'items-on-sale': 'No items on sale found. Please select a different merchant.',
		'new-products': 'No new products found. Please select a different merchant.',
		'publisher-overview': 'No publisher overview data available.',
		'search-trends': 'No search trends found. Please select a different merchant.',
		'top-articles': 'No stories available.',
		'total-earnings': 'No earnings stats available.',
		'total-revenue': 'No revenue stats available.',
		'strategy-typeahead': 'No results found.',
	};

	return noResult ? (
		<div className="no-result">
			{textMap[type]}
		</div>
	) : null;
};

export {
	Loader,
	NoResult,
};
